import ReactOnRails from 'react-on-rails'
import * as React from 'react'
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import { GrowthbookStoreProps } from '../../reducers/growthbook'

let globalGB: GrowthBook

export function withGrowthbook<P>(
  WrappedComponent: React.ComponentType<P>
): React.FC<P> {
  return function WithGrowthbookHoc(props: P): JSX.Element {
    // TODO could be replaced by fetching from our own api
    // prefer to load from our own backend to take advantage of our caching
    const store = ReactOnRails.getStore('growthbookStore') as {
      getState: () => GrowthbookStoreProps
    }
    const { features, attributes } = store.getState()

    const gb = React.useMemo(() => {
      if (globalGB) {
        globalGB.setFeatures(features)
        globalGB.setAttributes(attributes)
        return globalGB
      }

      if (Object.keys(features).length) {
        globalGB = new GrowthBook({
          features: features,
          attributes: attributes,
          enableDevMode:
            process.env.NODE_ENV === 'development' ||
            (typeof window !== 'undefined' &&
              window.location.host !== 'www.laced.com'),
          trackingCallback(experiment, result) {
            const url = '/api/feature_flag/track_experiment'
            const data = new FormData()

            data.set('experiment_id', experiment.key)
            data.set('variation_id', `${result.variationId}`)
            fetch(url, { body: data, method: 'POST' })
          }
        })
        return globalGB
      }

      return undefined
    }, [attributes, features])

    return (
      <GrowthBookProvider growthbook={gb}>
        {/* @ts-expect-error cause HOC are annoying */}
        <WrappedComponent {...props} />
      </GrowthBookProvider>
    )
  }
}
